/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/** Logging screen identifier for the Live TV carousel API endpoint. */
export const PLAYER_CAROUSEL_SCREEN_ID: string = "/livetv";

/** Player carousel screen name */
export const PLAYER_CAROUSEL_SCREEN_NAME: string = "playerCarousel";

/** API endpoint name used in operational apiRequest events for the Live TV carousel. */
export const PLAYER_CAROUSEL_API_ENDPOINT: string = "/smart-carousel/livetv";

/** Page size for the player carousel. */
export const PLAYER_CAROUSEL_PAGE_SIZE: number = 1;

/** Auto-dismiss timeout for the player carousel in milliseconds. */
export const PLAYER_CAROUSEL_AUTO_DISMISS_MS: number = 10 * 1000; // 10 seconds
